export const threatMetrics = (metric: string | undefined) => {
    if (!metric) return '00:00:00';
    if (metric.includes('d')) {
        return metric.slice(0, -3).replace(/\s+/g, '');
    }
    return metric;
};

export const formatSeconds = (seconds: number) => {
    const hours = String(Math.floor(seconds / 3600)).padStart(2, '0');
    const minutes = String(Math.floor((seconds % 3600) / 60)).padStart(2, '0');
    const secs = String(seconds % 60).padStart(2, '0');

    return `${hours}:${minutes}:${secs}`;
};
